<template>
    <div class="tabframe">
        <mt-tab-container :value="selected">
            <mt-tab-container-item v-for="tab in tabs" :key="tab.name" :id="tab.name">
                <slot></slot>
            </mt-tab-container-item>
        </mt-tab-container>
        <mt-tabbar v-model="selected" fixed>
            <mt-tab-item v-for="tab in tabs" :key="tab.name" :id="tab.name">
                <i slot="icon" :class="icon(tab)"></i>
                {{ tab.name }}
            </mt-tab-item>
        </mt-tabbar>
    </div>
</template>

<script>
    export default {
        name: "TabFrame",
        data() {
            return {
                selected: null
            }
        },
        computed: {
            tabs() {
                return this.$router.options.routes.filter(({meta}) => meta && meta.tab).map(route => ({
                    ...route.meta.tab,
                    path: route.path,
                }));
            },
        },
        watch: {
            selected(val) {
                let tab = this.tabs.filter(({name}) => name === val)[0];
                this.$router.push(tab.path);
            },
            $route() {
                this.select();
            }
        },
        created() {
            this.select();
        },
        methods: {
            icon(tab) {
                return tab.name === this.selected ? tab.iconActive : tab.icon;
            },
            select() {
                this.tabs.forEach(tab => {
                    if (this.$route.path.startsWith(tab.path)) {
                        this.selected = tab && tab.name;
                        return false;
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>